
import BiPaiSeatCards from "./bipai_seat_cards";

const { ccclass, property, menu } = cc._decorator;

@ccclass
@menu("custom/bipai/BiPaiSeatHandCards")
export default class BiPaiSeatHandCards extends BiPaiSeatCards{

    @property(cc.Float)
    intervalAngle: number = 0

    @property(cc.Float)
    offsetAngle: number = 0

    @property(cc.Float)
    targetScale: number = 1

    @property(cc.Float)
    radius: number = 0

    protected getPosData(index: number, count: number){
        let posAngle = this.calcPosAndAngle(index, count)
        let data: any = {}
        data.localPos = posAngle.localPos
        data.worldPos = this.nodePokersParent.convertToWorldSpaceAR(data.localPos)
        data.angle = posAngle.angle
        data.zIndex = posAngle.zIndex
        data.scale = this.targetScale
        return data
    }

    protected calcPosAndAngle(index: number, count: number){
        let radius = this.radius
        let intervalAngle = this.intervalAngle
        let midIndex = (count + 1) * 0.5
        let offsetIndex = index + 1 - midIndex
        let angle = this.offsetAngle + offsetIndex * intervalAngle
        let a = (angle + 90) / 180 * Math.PI        
        return {localPos: cc.v2(radius * Math.cos(a), radius * Math.sin(a)), angle: angle, zIndex: index}
    }
}
